import styled from "styled-components";

export const TableWrap = styled.div`
    margin-top: 1rem;
    cursor: default;
    overflow-x: auto;
    border-radius: 16px;
    padding: 40px;
    background: ${(props) => props.theme?.palette?.greyBackground ?? "#F3F7F9"};
`;

export const Table = styled.table`
    border-collapse: collapse;
    width: 100%;
    table-layout: fixed;
`;

export const TableBody = styled.tbody`
    cursor: default;
`;

export const TableRow = styled.tr`
    border-bottom: 2px solid #e9eff2;
    height: 46px;
`;

export const SelectHeader = styled.th`
    width: 90px;
`;

export const TightHeader = styled.th`
    width: 155px;
`;

export const CenterCell = styled.td<{ $selected?: boolean }>`
    text-align: center;
    background: ${(props) => (props.$selected ? "lightgrey" : "transparent")};

    input[type="radio"]:not([disabled])
    {
        cursor: pointer;
    }
`;

export const NameCell = styled.td`
    padding-left: 4px;
`;

export const MinorCell = styled.td<{ $isMinor?: boolean }>`
    text-align: center;
    background: ${(props) => (props.$isMinor ? "lightgrey" : "transparent")};
`;

export const KycCell = styled.td`
    text-align: center;
`;

export const NotifyOwnerWrap = styled.div`
    margin-top: 4px;
`;
